/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import { Text } from '../../';

/**
 *
 * @param {object} props
 * @param {import('./badgeVariants').BadgeVariant} [props.variant]
 * @param {React.ReactNode} props.children
 */
export default function Badge({ variant = 'default', children, ...rest }) {
  return (
    <Text
      variant="smallest"
      sx={{
        borderRadius: 'round',
        display: 'inline-block',
        paddingX: 2,
        marginRight: 'auto',
        variant: `badge.${variant}`,
      }}
      {...rest}
    >
      {children}
    </Text>
  );
}
